import {BrandingColors} from '@models/adminstration/organization/branding/branding-colors';
import {BrandingImages} from '@models/adminstration/organization/branding/branding-images';

export class Branding {
  id: number;
  colors: BrandingColors;
  images: BrandingImages;
  parentTenant: number;
  secondaryColorEnabled: boolean;

  constructor() {
    this.id = -1;
    this.colors = new BrandingColors();
    this.images = new BrandingImages();
    this.parentTenant = -1;
    this.secondaryColorEnabled = false;
  }
}
